import { render, staticRenderFns } from "./PublishReleaseButton.vue?vue&type=template&id=161522d8"
import script from "./PublishReleaseButton.vue?vue&type=script&lang=js"
export * from "./PublishReleaseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports